module.exports = ".fury-backdrop{z-index:800 !important;transition:background-color 300ms}\n"